export default "__VITE_ASSET___91RiGVg__"